import styled from 'styled-components'

export const IndicatorTable = styled.div`
  .headline-container {
    .headline {
      display: flex;
      flex-direction: row;
      padding-bottom: 20px;

      .tooltip {
        top: 3px;
      }
    }

    .sub-headline {
      font-size: 18px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.39;
      display: flex;
      flex-direction: column;
      font-weight: bold;
      text-align: start;
      color: ${ (props) => props.theme.colors['standard-schwarz'] };
    }
  }

  // whole table styles
  .indicator-table {
    max-width: 750px;

    .indicator-column {
      vertical-align: baseline;

      > span {
        margin-right: 5px;
      }
    }

    .result-column {
      padding-left: 0;
      padding-right: 0;
      vertical-align: top;

      .cell-column {
        border-collapse: collapse;

        > span:nth-child(2) {
          margin-top: 8px;
          font-weight: bold;
          color: ${ (props) => props.theme.colors['panel-inner-border'] };
        }

        > span:nth-child(3) {
          color: ${ (props) => props.theme.colors['panel-inner-border'] };
        }
      }
    }

    .referenceRange-column {
      padding-left: 0;
      padding-right: 0;
      vertical-align: top;
      text-align: center;
    }

    .cell-column {
      display: flex;
      flex-direction: column;
      align-items: center;

      > .title {
        font-weight: bold;
      }
    }

    .explanation-column {
      width: 50%;

      > .title {
        font-weight: bold;
      }

      .cell-column {
        align-items: start;
      }
    }

    .tooltip {
      position: relative;
      top: 1px;
      margin-left: 0;
    }

    .table-footer {
      margin-top: 21px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .treatmentCases-container {
        display: flex;
        flex-direction: row;

        .treatmentCases {
          color: ${ (props) => props.theme.colors['panel-inner-border'] };
        }

        .tooltip {
          position: relative;
          margin-left: 10px;
          top: 4px;

          > span[aria-hidden='false'] {
            display: initial;
          }
        }
      }

      > Button {
        text-align: right;
        width: auto;
        color: ${ (props) => props.theme.colors['standard-schwarz'] };

        @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
          text-align: left;
          margin-top: 30px;
        }
      }

      @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
        flex-direction: column;
      }
    }

    .flex-end {
      justify-content: flex-end;
    }

    .description {
      margin-top: 10px;
    }
  }
`
